import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const SnackbarNotification = ({ notification, setNotification }) => {
    const { i18n } = useTranslation();
    const handleClose = () => {
        setNotification({ show: false, snackbarMessage: '', severity: '' });
    };

    return (
        <Snackbar
            open={notification.show}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
        >
            <Alert
                onClose={handleClose}
                severity={notification.severity}
                variant="filled"
                sx={{
                    width: '100%',
                    color: 'white !important',
                    '& .MuiAlert-icon': {
                        color: 'white !important',
                        marginLeft: i18n.language === 'ar' ? '8px' : '0px',
                        marginRight: i18n.language === 'ar' ? '0px' : '8px'
                    },
                    textAlign: i18n.language === 'ar' ? 'right' : 'left',
                }}
                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
            >
                {notification.snackbarMessage}
            </Alert>
        </Snackbar>
    );
};

SnackbarNotification.propTypes = {
    notification: PropTypes.shape({
        show: PropTypes.bool,
        severity: PropTypes.oneOf(["error","info","success","warning", ""]),
        snackbarMessage: PropTypes.string
    }),
    setNotification: PropTypes.func
}
export default SnackbarNotification;